import { ProjectPhoto } from '@/app/api';
import { isImageLandscapeOriented } from '@/app/utils/image';

import MediaDisplay, { MediaType } from '@/app/components/MediaDisplay/MediaDisplay';

interface ProjectFinishedCoverMediaProps {
  coverImage: ProjectPhoto;
  mainVideoSlug?: string;
  coverImageAlt?: string;
}

const ProjectFinishedCoverMedia = ({ coverImage, coverImageAlt, mainVideoSlug }: ProjectFinishedCoverMediaProps) => {
  if (mainVideoSlug) {
    return (
      <div className="mt-[16px] mb-[40px] ml-[-24px] mr-[-24px] lg:ml-0 lg:mr-0 sm:w-full lg:max-w-[592px] sm:mt-0 sm:mb-0">
        <div className="m-0 rounded-md overflow-hidden bg-primary-light relative pb-[62.5%]">
          <MediaDisplay
            type={MediaType.VIDEO}
            videoUrl={`https://www.youtube.com/embed/${mainVideoSlug}?controls=1&enablejsapi=1`}
            imageUrl={`https://img.youtube.com/vi/${mainVideoSlug}/hqdefault.jpg`}
            sizes="100vw, (min-width: 640px) 790px, (min-width: 1024px) 640px"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mt-[16px] mb-[40px] lg:ml-0 lg:mr-0 sm:w-full lg:max-w-[592px] sm:mt-0 sm:mb-0">
      <div className="m-0 rounded-md overflow-hidden bg-primary-light relative pb-[62.5%]">
        <MediaDisplay
          type={MediaType.IMAGE}
          largeImageSrc={coverImage.sizes.fullCropped.path}
          smallImageSrc={coverImage.sizes.miniCropped.path}
          sizes="100vw, (min-width: 640px) 790px, (min-width: 1024px) 640px"
          alt={coverImageAlt}
          isLandscapeOriented={isImageLandscapeOriented(coverImage)}
        />
      </div>
    </div>
  );
};

export default ProjectFinishedCoverMedia;
